import { useTranslation } from "react-i18next";

const defaultRender = (value) => (value ? value : "0.00");
const useTransactionCell = () => {
    const { t } = useTranslation();

    return [
        { title: t("time"), dataIndex: 'dateTime', render: defaultRender, },
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t('amount'), dataIndex: 'amount', render: defaultRender, },
        {
            title: t('transactionType'), dataIndex: 'type', render: (value) => {
                if (value === 1) return "Deposit";
                return "Unknown";
            },
        },
    ];
};

export default useTransactionCell;
